import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import styles from "./styles/subform-list-sortable.css.js";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const SubformListSortable = ({
  name,
  newElementAdded,
  elements,
  className,
  onChange,
  elementComponent: ElementComponent,
  elementComponentProps,
  remove,
  form,
  move,
  classes,
}) => {
  const handleDragStop = result => {
    if (!result.destination) {
      return;
    }

    const newElements = Array.from(elements);
    const [removed] = newElements.splice(result.source.index, 1);
    newElements.splice(result.destination.index, 0, removed);

    onChange(name)(newElements.map((element, order) => ({ ...element, order })));
  };

  return (
    <DragDropContext onDragEnd={handleDragStop}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef} className={classes.list}>
            {elements && elements.length > 0
              ? elements
                  .sort((a, b) => a.order - b.order)
                  .map((element, index) => (
                    <Draggable key={element.id} draggableId={element.id} index={index}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{ ...provided.draggableProps.style }}
                          className={classes.element}
                          id={element.id}
                        >
                          <ElementComponent
                            index={index}
                            collectionName={name}
                            element={element}
                            newElementAdded={newElementAdded}
                            onChange={onChange}
                            onDelete={() => remove(index)}
                            form={form}
                            sortable
                            {...elementComponentProps}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))
              : null}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

SubformListSortable.propTypes = {
  /**
   * Nombre del array que contiene los elementos del subformulario
   */
  name: PropTypes.string.isRequired,
  /**
   * Indica si se ha creado un elemento recientemente
   */
  newElementAdded: PropTypes.bool,
  /**
   * Array con los elementos del subformulario
   */
  elements: PropTypes.array,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Callback que se llama al cambiar el estado del formulario compuesto
   */
  onChange: PropTypes.func,
  /**
   * Componente que renderiza un elemento a su representación en formulario
   */
  elementComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  /**
   * Props adicionales para el componente del elemento
   */
  elementComponentProps: PropTypes.object,
  /**
   * Función para borrar el elemento del listado
   */
  remove: PropTypes.func,
  /**
   * Estado y helpers de Formik
   */
  form: PropTypes.object,
  /**
   * Cambia de índice un elemento
   */
  move: PropTypes.func,
};

export default withStyles(styles)(SubformListSortable);
